import React from "react";
import { Bar } from "react-chartjs-2";
import { Box, Card, Grid, Stack, Typography } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { numberFormatter } from "utils/HelperFunctions";

const TeamTile = React.memo(({ team, setSelectedTeam }) => (
  <Grid item xs={12} sm={6} md={6} lg={4} key={team.id}>
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        cursor: "pointer",
      }}
      onClick={() => setSelectedTeam(team)}
    >
      <Typography variant="h5" component="h5">
        {team?.name}
      </Typography>
      <MDTypography variant="h6" mt={0} mb={1} fontStyle="italic">
        {team?.totalKpiCompleted || 0}
        <MDTypography variant="caption" sx={{ marginLeft: "2px", fontWeight: 800 }}>
          total kpis
        </MDTypography>
      </MDTypography>

      <Stack direction="column" width="100%" height="100%">
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="end"
          data-testid={`percentage-display-${team?.teamId}`}
        >
          <Typography sx={{ color: team?.hexColor, fontSize: "4rem" }}>
            {Math.round(numberFormatter(team?.percentage || 0), 10)}
          </Typography>
          <Typography
            sx={{
              color: team?.hexColor,
              fontSize: "1.5rem",
              pl: "0.2rem",
              pb: "1.5rem",
            }}
          >
            %
          </Typography>
        </Stack>
        <Box height="25px" width="99%">
          <Bar options={team?.barOptions} data={team?.barData} />
        </Box>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="end">
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="end"
          data-testid={`points-display-${team?.teamId}`}
        >
          <Typography sx={{ fontStyle: "italic", fontSize: "1.5rem" }}>
            {team?.totalAchievedPoints}
          </Typography>
          <Typography
            sx={{
              fontStyle: "italic",
              fontSize: "0.8rem",
              pl: "0.2rem",
              pb: "0.3rem",
            }}
          >
            points
          </Typography>
        </Stack>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="end"
          data-testid={`target-display-${team?.teamId}`}
        >
          <Typography
            sx={{
              fontStyle: "italic",
              fontSize: "1.5rem",
              ...(team?.totalAchievedPoints >= team?.totalCompletedKpis ? {} : { color: "#888" }),
            }}
          >
            {team.totalCompletedKpis}
          </Typography>
          <Typography
            sx={{
              fontStyle: "italic",
              fontSize: "0.8rem",
              pl: "0.2rem",
              pb: "0.3rem",
              ...(team?.totalAchievedPoints >= team?.totalCompletedKpis ? {} : { color: "#888" }),
            }}
          >
            target
          </Typography>
        </Stack>
      </Stack>
    </Card>
  </Grid>
));

const TableListingForManagerGridView = React.memo(({ data, setSelectedTeam }) => (
  <MDBox sx={{ position: "relative" }}>
    {/* Card block inside grid */}
    <Grid
      container
      spacing={4}
      direction="row"
      justifyContent="flex-start"
      alignItems="stretch"
      data-testid="team-list-grid-container"
    >
      {data?.map((team) => (
        <TeamTile key={team.teamId} team={team} setSelectedTeam={setSelectedTeam} />
      ))}
    </Grid>
  </MDBox>
));

export default TableListingForManagerGridView;
